import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BillingTransfersState } from './billing.transfers.models';

export const selectBillingTransfersState =
  createFeatureSelector<BillingTransfersState>('billingTransfers');

export const selectTransfers = createSelector(
  selectBillingTransfersState,
  (state) => state.transfers,
);

export const selectTransfersLoading = createSelector(
  selectBillingTransfersState,
  (state) => state.loading,
);

export const selectTransfersTotalCount = createSelector(
  selectBillingTransfersState,
  (state) => state.transfersPage?.totalCount ?? 0,
);

export const selectTransferFilterParameters = createSelector(
  selectBillingTransfersState,
  (state) => state.filterParameters,
);

export const selectTransferCurrentFilter = createSelector(
  selectBillingTransfersState,
  (state) => state.currentFilter,
);

export const selectTransferPagination = createSelector(
  selectBillingTransfersState,
  (state) => state.pagination,
);

export const selectTransferOperatorId = createSelector(
  selectBillingTransfersState,
  (state) => state.operatorId,
);

export const selectTransferDateFrom = createSelector(
  selectBillingTransfersState,
  (state) => state.dateFrom,
);

export const selectTransferDateTo = createSelector(
  selectBillingTransfersState,
  (state) => state.dateTo,
);
